import styles from '../markers.module.scss';
import { Tooltip } from 'react-leaflet';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { useTranslation } from 'react-i18next';
import { getObjectIcon, IconColor } from '../icons';
import RotatableMarker from '../rotatable-marker/RotatableMarker';
import { RotationModel } from '../utils';
import { useMemo } from 'react';
import { Icon } from 'leaflet';

export enum ObjectEventType {
  Start = 'Start',
  End = 'End',
}

export interface ObjectEventMarkerProps extends RotationModel {
  eventType: ObjectEventType;
  time: string;
}

export function ObjectEventMarker({ eventType, time, position, heading }: ObjectEventMarkerProps) {
  const { t } = useTranslation();
  const { showTimeAndDateFromIso } = useLocaleFormatter();

  const icon = useMemo<Icon>(() => {
    const iconColor = eventType === ObjectEventType.Start ? IconColor.Red : IconColor.Green;
    return getObjectIcon(iconColor, heading);
  }, [eventType, heading]);

  return (
    <RotatableMarker icon={icon} position={position} heading={heading}>
      <Tooltip className="tooltip-override" offset={[30, 0]}>
        <div className={styles.popup}>
          <span className={styles.popup__name}>{t(`MapObjectEvents.${eventType}`)}</span>
          <br />
          <span>{showTimeAndDateFromIso(time)}</span>
        </div>
      </Tooltip>
    </RotatableMarker>
  );
}

export default ObjectEventMarker;
